/*===================================================================
=    Spending DEMAND API                     =
====================================================================*/

import axios from "axios";

import { generateURLQuery } from "../../../utils/urlQueryGenerator";
import { ResponseAPIWithPagination } from "../../../types/responsesAPI.types";
import { FilterSpendingDemand, SPDF, SpendingDemand, SpendingDemandExtended } from "../types/spendingDemand.types";
import { FilterpendingDemandConverterToQuery } from "../utils/filterConverter";
import { SpendingDemandHistoricStatus } from "../types/spendingDemandHistoricStatut.types";
import { FileUrl } from "../../../components/molecules/FileListManager/FileListManager";
import { FileDtoIn, FileDtoOut } from "../../../types/file.type";
import { convertFileToFileDto } from "../../../utils/fileReader";

/**
 * Sending demand api request
 * 
 * All API protected required the use call of 
 */
const BASE_URL = process.env.REACT_APP_URL_BACKEND




export function fetchAllSpendingDemandsAPIProtectedV2(pageSize: number | null, page: number | null,userId: string | undefined, filterOptions?: FilterSpendingDemand | null) {

  console.log(filterOptions)
  const {queryArray} = FilterpendingDemandConverterToQuery(filterOptions) 

  const queryList = [
    {
      key: "pageSize",
      value: pageSize
    },
    {
      key: "currentPage",
      value: page
    },
    {
      key: "extendedfields",
      value: "user,project"
    },
    {
      key: "managerEmployeeId",
      value: userId
    },
    ...queryArray
  ]


  
  const query = generateURLQuery(queryList)

  console.log('query='+query)

  

  
  return axios.get<ResponseAPIWithPagination<SpendingDemandExtended>>(`${BASE_URL}/api/v2/spendingdemands${query}`);
}

export function fetchSingleSpendingDemandAPIProtectedV2(spendingDemandId: string, managerEmployeeId?: string) {
  return axios.get<SpendingDemandExtended>(`${BASE_URL}/api/v2/spendingdemands/${spendingDemandId}`+
  "?extendedfields=user,project"
  );
}

/**
 * Builds query params for the User spending demands API from FilterSpendingDemand.
 * Uses whereQuery and orderByQuery for parity with Admin filters (type, readableId, boxId, etc.).
 */
function filterToUserAPIQueryParams(filter: FilterSpendingDemand | null | undefined): { key: string; value: string | null }[] {
  if (!filter) return [];
  const { queryArray } = FilterpendingDemandConverterToQuery(filter);
  return queryArray
    .map((item) => {
      if (item.key === "orderBy") {
        return { key: "orderByQuery", value: item.value };
      }
      if (item.key === "whereQuery" || item.key === "orderByQuery") {
        return item;
      }
      return null;
    })
    .filter((item): item is { key: string; value: string | null } => item !== null && item.value !== null);
}

export function fecthAllSpendingDemandOfUserAPIProtectedV2(
  pageSize: number | null,
  page: number | null,
  userId: string,
  filter?: FilterSpendingDemand | null
) {
  const baseQueryList = [
    { key: "pageSize", value: pageSize },
    { key: "currentPage", value: page },
    { key: "extendedfields", value: "project" },
  ];
  const filterParams = filterToUserAPIQueryParams(filter);
  const query = generateURLQuery([...baseQueryList, ...filterParams]);
  return axios.get<ResponseAPIWithPagination<SpendingDemandExtended>>(
    `${BASE_URL}/api/v2/compta/users/${userId}/spending_demands${query}`
  );
}

export const validateSpendingDemandRequest = async (spendingDemandId: string, message?: string) => {
  return await axios.post(`${BASE_URL}/api/v2/spendingdemands/${spendingDemandId}/validate`, {message})
}
 
export const closeSpendingDemandRequest = async (spendingDemandId: string) => {
  return await axios.post(`${BASE_URL}/api/v2/compta/spendingdemands/${spendingDemandId}/close`)
}

export const askForUpdateSpendingDemandRequest = async (spendingDemandId: string, message: string) => {
  return await axios.post(`${BASE_URL}/api/v2/spendingdemands/${spendingDemandId}/ask_for_update`, {message})
}

export const refuseSpendingDemandRequest = async (spendingDemandId: string, message: string) => {
  return await axios.post(`${BASE_URL}/api/v2/spendingdemands/${spendingDemandId}/refuse`, {message})
}

const getFetchSingleSpendingDemandAPIProtectedV2 = async (spendingDemandId: string, managerEmployeeId?: string) => {
    return (await fetchSingleSpendingDemandAPIProtectedV2(spendingDemandId, managerEmployeeId)).data;
}

const validateSpendingDemandAPIProtected = async (spendingDemandId: string, message?: string) => {
  return (await validateSpendingDemandRequest(spendingDemandId, message)).data
}

const askForUpdateSpendingDemandAPIProtected = async (spendinDemandId: string, message: string) => {
  return (await  askForUpdateSpendingDemandRequest(spendinDemandId, message) ).data
}

const refuseSpendingDemandAPIProtected = async (spendinDemandId: string, message: string) => {
  return (await refuseSpendingDemandRequest(spendinDemandId, message)).data
}

const modifySpendingDemandAPIProtected = async (spendinDemandId: string, spendingDemandDto: Partial<SpendingDemand>) => {
  return (await axios.post<SpendingDemand>(`${BASE_URL}/api/v2/spendingdemands/${spendinDemandId}/do_correction`, spendingDemandDto)).data

}

const getFetchAllSpendingDemand = async (pageSize:number | null ,page: number, filter: FilterSpendingDemand | null | undefined, userId: string, forUser: boolean ) => {
  if(forUser) {
    return (await fecthAllSpendingDemandOfUserAPIProtectedV2(pageSize || 8, page, userId, filter)).data
  }else{
    return (await fetchAllSpendingDemandsAPIProtectedV2(pageSize || 8, page,userId, filter)).data
  }
}

const cancelSpendingDemandAPIProtected = async (spendingDemandId: string) => {
  return (await axios.post(`${BASE_URL}/api/v2/spendingdemands/${spendingDemandId}/cancel`)).data
}

const getFetchHistoricStatusSpendingDemand = async (spendingDemandId: string) => {
  return (await (axios.get<ResponseAPIWithPagination<SpendingDemandHistoricStatus>>(`${BASE_URL}/api/v2/spendingdemands/${spendingDemandId}/status_historics?extendedfields=user`))).data
}

const newDemandSpendingAPI = async (spendingDemand: Partial<SpendingDemand>) => {
  return (await axios.post<SpendingDemand>(`${BASE_URL}/api/v2/spendingdemands`, spendingDemand)).data
}

export const setPayed = async (spendingDemandId: string) => {
  return (await axios.post(`${BASE_URL}/api/v2/spendingdemands/${spendingDemandId}/set_payed`)).data
}

export const setClose = async (spendingDemandId: string) => {
  return (await closeSpendingDemandRequest(spendingDemandId)).data
}

export const addNewFileToSpendingDemandAPI = async (spendingDemandId: string, fileURL: FileUrl) => {
  const fileList : FileDtoIn[]  | undefined =fileURL ? await convertFileToFileDto([fileURL]) : undefined
  const file = fileList?.[0] || null;
  console.log("file", file)
  if (file && !file.ignore) {
    return (await axios.post<FileDtoOut>(`${BASE_URL}/api/v2/compta/spendingdemands/${spendingDemandId}/files`, file)).data
  }

  if (!file) {
    return Promise.reject(new Error("File is not valid") as any);
}

}

// Password wire contract (pinned): custom header X-File-Delete-Password, validated by the Go backend
// (password + admin role). password is optional to keep pre-existing unprotected call sites compiling;
// the backend guard will reject a missing/incorrect password once its hardening ships (see plan Step 4/8).
export const deleteFileOfSpendingDemandAPI = async (spendingDemandId: string, spendingDemandFileId: string, password?: string) => {
  return (await axios.delete(`${BASE_URL}/api/v2/compta/spendingdemands/${spendingDemandId}/files/${spendingDemandFileId}`, {
    headers: password ? { "X-File-Delete-Password": password } : undefined,
  })).data
}

export const getListFilesOfSpendingDemandAPI = async (spendingDemandId: string) => {
  return (await axios.get<ResponseAPIWithPagination<SPDF>>(`${BASE_URL}/api/v2/compta/spendingdemands/${spendingDemandId}/files`)).data
}



// Extract API functions
export const startExtractSpendingDemandsAPI = async (whereQuery?: string, orderBy?: string, startDate?: string, endDate?: string, categoryId?: string, supplierId?: string, projectId?: string, userId?: string, adminId?: string, managerEmployeeId?: string, fields?: string[]) => {
  const queryParams = new URLSearchParams();
  
  if (whereQuery) queryParams.append('whereQuery', whereQuery);
  if (orderBy) queryParams.append('orderBy', orderBy);
  if (startDate) queryParams.append('startDate', startDate);
  if (endDate) queryParams.append('endDate', endDate);
  if (categoryId) queryParams.append('categoryId', categoryId);
  if (supplierId) queryParams.append('supplierId', supplierId);
  if (projectId) queryParams.append('projectId', projectId);
  if (userId) queryParams.append('userId', userId);
  if (adminId) queryParams.append('adminId', adminId);
  if (managerEmployeeId) queryParams.append('managerEmployeeId', managerEmployeeId);
  if (fields && fields.length > 0) queryParams.append('fields', fields.join(','));

  const queryString = queryParams.toString();
  const url = `${BASE_URL}/api/v2/compta/spendingdemands/extract${queryString ? `?${queryString}` : ''}`;
  
  return (await axios.get<{processID: string}>(url)).data;
}

export const getExtractStatusAPI = async (processID: string) => {
  return (await axios.get<{status: string, total: number, actual: number}>(`${BASE_URL}/api/v2/compta/spendingdemands/extract/status/${processID}`)).data;
}

export const downloadExtractAPI = async (processID: string) => {
  return await axios.get(`${BASE_URL}/api/v2/compta/spendingdemands/extract/download/${processID}`, {
    responseType: 'blob'
  });
}

// User-scoped extract: /extract (not /manager/extract), scoped to authenticated user
export const startExtractSpendingDemandsUserAPI = async (whereQuery?: string, orderByQuery?: string, fields?: string[]) => {
  const queryParams = new URLSearchParams();
  if (whereQuery) queryParams.append('whereQuery', whereQuery);
  if (orderByQuery) queryParams.append('orderByQuery', orderByQuery);
  if (fields && fields.length > 0) queryParams.append('fields', fields.join(','));
  const queryString = queryParams.toString();
  const url = `${BASE_URL}/api/v2/compta/spendingdemands/extract${queryString ? `?${queryString}` : ''}`;
  return (await axios.get<{processID: string}>(url)).data;
}

// Extract API functions V2 - Manager route
// Utilise whereQuery au format useGenericQuery (ex: "spending_demand_status=VALIDATE|spending_demand_type<in>[TYPE1,TYPE2]")
export const startExtractSpendingDemandsManagerAPI = async (whereQuery?: string, orderBy?: string, fields?: string[], querySearch?: string, descSearch?: string) => {
  const queryParams = new URLSearchParams();

  if (whereQuery) queryParams.append('whereQuery', whereQuery);
  if (orderBy) queryParams.append('orderByQuery', orderBy);
  if (fields && fields.length > 0) queryParams.append('fields', fields.join(','));
  if (querySearch) queryParams.append('query', querySearch);
  if (descSearch) queryParams.append('descSearch', descSearch);

  const queryString = queryParams.toString();
  const url = `${BASE_URL}/api/v2/compta/spendingdemands/manager/extract${queryString ? `?${queryString}` : ''}`;
  
  return (await axios.get<{processID: string}>(url)).data;
}

export const getExtractStatusManagerAPI = async (processID: string) => {
  return (await axios.get<{status: string, total: number, actual: number}>(`${BASE_URL}/api/v2/compta/spendingdemands/manager/extract/status/${processID}`)).data;
}

export const downloadExtractManagerAPI = async (processID: string) => {
  return await axios.get(`${BASE_URL}/api/v2/compta/spendingdemands/manager/extract/download/${processID}`, {
    responseType: 'blob'
  });
}

export const API_BASE_URL_SPENDING_DEMAND_MANAGER = `${BASE_URL}/api/v2/compta/spendingdemands/manager`

export const spendingDemandAPI = {
  getFetchSingleSpendingDemandAPIProtectedV2,
  validateSpendingDemandAPIProtected,
  askForUpdateSpendingDemandAPIProtected,
  refuseSpendingDemandAPIProtected,
  getFetchAllSpendingDemand,
  getFetchHistoricStatusSpendingDemand,
  newDemandSpendingAPI,
  cancelSpendingDemandAPIProtected,
  modifySpendingDemandAPIProtected,
  setPayed,
  setClose,
  addNewFileToSpendingDemandAPI,
  getListFilesOfSpendingDemandAPI,
  deleteFileOfSpendingDemandAPI,
  startExtractSpendingDemandsAPI,
  startExtractSpendingDemandsUserAPI,
  getExtractStatusAPI,
  downloadExtractAPI,
  startExtractSpendingDemandsManagerAPI,
  getExtractStatusManagerAPI,
  downloadExtractManagerAPI,
  closeSpendingDemandRequest
}

export default spendingDemandAPI